import React from 'react';
import {Link} from 'react-router';

export default class Logo extends React.Component {
    render() {
        return <Link to="/"><img className="logo logo-beta" src="/img/logo.svg" alt="Medita Logo" /></Link>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Logo.js